export * from './besichtigung-gespeichert.interface';
